<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog(1)"
      addShowPower="/copymerchantInfoManage/add"
      :goback="false"
      :selectShow="false"
    >
    </common-top-form>

    <div
      style="
        display: flex;
        font-size: 15px;
        font-weight: bold;
        margin-bottom: 15px;
        align-items: center;
      "
    >
      <el-button
        style="margin: 0px 15px 0px 0px"
        type="primary"
        class="button-size-back"
        @click="handleFront"
        >返回上一级</el-button
      >
      <span>商户号：{{ this.impiementall.merNo || "暂无" }} </span>
      <span style="margin: 0px 15px 0px 15px"
        >商户名：{{ this.impiementall.merName || "暂无" }}
      </span>
      <span style="margin: 0px 15px 0px 0px"
        >代理商ID：{{ this.impiementall.agentId || "暂无" }}
      </span>
      <span>通道名称：{{ tongdao || "暂无" }} </span>
    </div>
    <common-table :data="tableData" ref="commonTable" :isShow="false">
      <el-table-column
        prop="agentNo"
        label="代理商ID"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="agentName"
        label="代理商姓名"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="agentPhone"
        label="代理商手机号"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="sn"
        label="SN"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="terminalId"
        label="终端号"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="hardwareType"
        label="硬件产品类型"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="activeSubType"
        label="子活动类型"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="绑定时间"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        v-if="hasPerm('/copymerchantInfoManage/del')"
        label="操作"
        min-width="200"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="handleDelete(scope.row)"
            >解绑
          </el-button>
          <el-button
            v-if="
              scope.row.hardwareType == '乐银付_TY_TP10V1.0' ||
              scope.row.hardwareType == 'SP620' ||
              scope.row.hardwareType == '乐银付_TY_TP10V2.0'
            "
            type="text"
            @click="openAddDialog(2, scope.row)"
            >修改子活动类型
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      dialogWidth="780px"
    >
      <div v-if="flag == 1">
        <div style="display: flex">
          <el-form-item label="SN号" label-width="65px">
            <el-input
              minlength="8"
              type="text"
              v-model.trim="dialogModel.sn"
              placeholder="请输入"
              style="width: 203.33px; margin-right: 0px"
            ></el-input>
          </el-form-item>
          <el-form-item label="代理商ID" prop="agentNo">
            <el-input
              type="text"
              v-model.trim="dialogModel.agentNo"
              placeholder="请输入"
              style="width: 203.33px; margin-right: 0px"
              :disabled="
                this.impiementall.agentId == null
                  ? false
                  : this.impiementall.agentId == ''
                  ? false
                  : true
              "
            ></el-input>
          </el-form-item>
          <el-button
            style="width: 40px; height: 40px"
            type="primary"
            icon="el-icon-search"
            circle
            @click="posSnAll()"
          ></el-button>
        </div>
        <el-row class="bank-list-box">
          <el-form-item label="请勾选" label-width="65px" prop="terminalIds">
            <div>
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="isIndeterminate"
                @change="handleCheckAllChange"
                class="checkbox"
              >
                <div class="title">
                  <span>SN</span>
                  <span>终端号</span>
                  <span>硬件产品类型</span>
                </div>
              </el-checkbox>
            </div>
            <el-checkbox-group
              v-model="dialogModel.terminalIds"
              @change="handleCheckedCitiesChange"
            >
              <div
                class="flex-row vertical-center bank-box"
                v-for="(item, index) in formDialogData"
                :key="index"
              >
                <el-checkbox :key="item.sn" :label="item.sn" class="checkbox1">
                  <div class="neirong">
                    <span>{{ item.sn }}</span>
                    <span>{{ item.terminalNo }}</span>
                    <span>{{ item.hardwareType }}</span>
                  </div>
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </el-form-item>
        </el-row>
      </div>
      <div v-if="flag == 2">
        <el-form-item
          label-width="120px"
          label="子活动类型"
          prop="activeSubType"
        >
          <el-select style="width: 350px" v-model="dialogModel.activeSubType">
            <el-option
              v-for="item in activeSubType"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";

import OrganService from "service/OrganService";
import PosService from "service/PosService";
import TransactionService from "service/TransactionService";
import StorageService from "store/interfaces";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "copymerchantInfoManage",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    return {
      itemId: "",
      flag: "",
      isIndeterminate: false,
      impiementall: {},
      show: false,
      formModel: {
        name: "",
      },
      tableData: [],
      activeSubType: [],
      formDialogData: [],
      multipleSelection: [],
      submitService: OrganService.copymerchantInfoManageList,
      dialogModel: {
        sn: "",
        agentNo: "",
        merNo: "",
        terminalIds: [],

        activeSubType: "",
      },
      chnCode: [],
      tongdao: "",
      dialogRules: {
        agentNo: [{ required: true, message: "请输入" }],
        activeSubType: [{ required: true, message: "请选择" }],
        terminalIds: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value.length) {
                callback(new Error("请勾选"));
              } else {
                return callback();
              }
            },
          },
        ],
      },
      isFlag: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  created() {
    this.impiementall = JSON.parse(this.$route.params.item);
    this.getTypeNames("chnName", (res) => {
      this.chnCode = [...this.chnCode, ...res];
      this.matchFields();
    });
  },

  mounted() {
    this.setBasicInfoFlag(false);
    this.load();
  },
  computed: {
    submitData() {
      this.params = {
        merNo: this.impiementall.merNo,
      };
      return this.params;
    },
    dialogData() {
      let params = {};
      switch (this.flag) {
        case 1: //添加
          params = {
            merNo: this.impiementall.merNo,
            agentNo: this.dialogModel.agentNo,
            terminalIds: this.dialogModel.terminalIds,
          };
          break;
        case 2: //修改
          params = {
            activeSubType: this.dialogModel.activeSubType,
            sn: this.itemId,
          };
          break;
        default:
          break;
      }
      return params;
    },
    color() {
      if (this.multipleSelection.length == 0) {
        return "red";
      } else if (this.multipleSelection.length != 0) {
        return "black";
      }
    },
    dialogService() {
      return this.itemId
        ? OrganService.copymerchantInfoManageEdit
        : OrganService.copymerchantInfoManageInsert;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {
    basicInfoFlag: {
      handler(val, oldVal) {
        if (val) {
          this.setBasicInfoFlag(false);
        }
      },
    },
  },
  methods: {
    load() {
      this.formModel = {};
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
          });
        },
        "信息获取失败"
      );
    },
    getactiveSubType() {
      this.doLoad(
        TransactionService.apppointsnewodetojoymanageList,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.activeSubType = res.contents;
          });
        },
        "信息获取失败"
      );
    },
    getactiveSubType1() {
      this.doLoad(
        TransactionService.ysposapppointsnewodetojoymanageList,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.activeSubType = res.contents;
          });
        },
        "信息获取失败"
      );
    },
    getactiveSubType2() {
      this.doLoad(
        TransactionService.twoapppointsnewodetojoymanageList,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.activeSubType = res.contents;
            console.log(this.activeSubType);
          });
        },
        "信息获取失败"
      );
    },
    matchFields() {
      this.chnCode.forEach((item) => {
        if (item.dictKey == this.impiementall.chnCode) {
          this.tongdao = item.dictValue;
        }
      });
    },
    handleDelete(item) {
      this.showConfirm("是否解绑？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        OrganService.copymerchantInfoManageDel,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    openAddDialog(flag, item) {
      this.flag = flag;
      this.dialogModel.agentNo = this.impiementall.agentId;
      this.itemId = item ? item.sn : "";
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
        switch (this.dialogModel.hardwareType) {
          case "乐银付_TY_TP10V1.0":
            this.getactiveSubType(); //鼓励金配置接口
            break;
          case "SP620":
            this.getactiveSubType1(); //银盛大pos鼓励金配置接口
            break;
          case "乐银付_TY_TP10V2.0":
            this.getactiveSubType2(); //鼓励金配置2.0接口
            break;
          default:
            break;
        }
      }
      this.$refs.formDialog.open();
    },

    dialogClose() {
      this.dialogModel = {
        sn: "",
        agentNo: "",
        terminalIds: [],

        activeSubType: "",
      };
      this.itemId = "";
      this.flag = "";
      this.formDialogData = [];
      this.multipleSelection = [];
      this.isIndeterminate = false;
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.setBasicInfoFlag(true);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result;
      });
    },
    posSnAll() {
      if (!this.dialogModel.agentNo) {
        this.$refs.formDialog.validateField("agentNo");
      } else {
        const params = {
          sn: this.dialogModel.sn,
          agentNo: this.dialogModel.agentNo,
          status: 1,
        };
        this.doLoad(
          PosService.getposSnAllStandby,
          params,
          (res) => {
            this.doCheck(res, (res) => {
              this.formDialogData = res.contents;
            });
          },
          "信息获取失败"
        );
      }
    },
    checkboxT(row, index) {
      return true;
    },
    handleFront() {
      this.$router.push({
        name: "copymerchantInfo",
      });
    },
    handleCheckAllChange(val) {
      this.dialogModel.terminalIds = [];
      this.formDialogData.forEach((item) => {
        this.dialogModel.terminalIds.push(item.sn);
      });
      this.dialogModel.terminalIds = val ? this.dialogModel.terminalIds : [];
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.isIndeterminate !== checkedCount > 0 &&
        checkedCount < this.formDialogData.length;
      this.isIndeterminate = checkedCount == this.formDialogData.length;
    },
    ...mapActions({
      setBasicInfoFlag: StorageService.Reload.basicInfoFlag,
    }),
  },
};
</script>

<style scoped>
.checkbox {
  padding-left: 10px;
  margin-top: -5.5px;
  height: 50px;
  min-width: 588px;
  background: #f9f9f9;
}

.title {
  min-width: 564px;
  display: flex;
  justify-content: space-around;
}
.title span {
  color: #000;
  padding-top: 17px;
  font-size: 14px;
  font-weight: bold;
  width: 120px;
  text-align: center;
}
.checkbox1 {
  padding-left: 10px;
  min-width: 598px;
  background: rgba(7, 154, 222, 0.06);
}
.neirong {
  min-width: 564px;
  display: flex;
  justify-content: space-around;
}
.neirong span {
  width: 120px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/CopyMerchantInfoManage.vue